import { observer } from 'mobx-react-lite'
import { WorkspacePostingDialogContainer } from '@/features/admin/staffing/components/WorkspacePostingDialog/WorkspacePostingDialogContainer'
import { type UpdateWorkspacePostingDialogViewModel } from './UpdateWorkspacePostingDialogViewModel'

export interface UpdateWorkspacePostingDialogContainerProps {
  vm: UpdateWorkspacePostingDialogViewModel
}

export const UpdateWorkspacePostingDialogContainer = observer(
  function UpdateWorkspacePostingDialogContainer({
    vm,
  }: UpdateWorkspacePostingDialogContainerProps) {
    return (
      <WorkspacePostingDialogContainer
        vm={vm}
        title="Edit post"
        buttonText="Save Changes"
      />
    )
  },
)
